import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Container,
  Paper,
  Grid,
  Button,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import api from '../../core/axiosInstance';
import { useParams } from 'react-router-dom';
import Bill from '../common/Bill';
import Slip from '../common/Slip';
import { formatDate, formatDateTime } from '../common/formatDate';

function extractAssets(assets) {
  let line = '';

  const land = assets.find((a) => a.name === 'Land');
  const vehicle = assets.find(
    (a) => ['Car', 'Motorbike', 'Truck'].indexOf(a.name) !== -1
  );
  if (land) {
    line += 'โฉนดที่ดิน ';
    line += `เลขที่โฉนด: ${getMeta(land.metas, 'deedNo')} ระวาง: ${getMeta(
      land.metas,
      'liable'
    )} เลขที่ดิน: ${getMeta(land.metas, 'landNo')} หน้าสำรวจ: ${getMeta(
      land.metas,
      'tambonNo'
    )} ตำบล${getMeta(land.metas, 'tambon')} อำเภอ: ${getMeta(
      land.metas,
      'อำเภอ'
    )} จังหวัด: ${getMeta(land.metas, 'province')} ขนาดที่ดิน: ${getMeta(
      land.metas,
      'size_Rai',
      '0'
    )} ไร่ ${getMeta(land.metas, 'size_Ngarn')} งาน ${getMeta(
      land.metas,
      'size_Wa'
    )} ตร.วา`;
  }

  if (vehicle) {
    if (vehicle.name === 'Car') {
      line += 'รถยนต์ ';
    }
    if (vehicle.name === 'Motorbike') {
      line += 'รถจักรยานยนต์ ';
    }
    if (vehicle.name === 'Truck') {
      line += 'รถบรรทุก ';
    }

    line += ` ยี่ห้อ: ${getMeta(vehicle.metas, 'brand')}`;
    line += ` รุ่น: ${getMeta(vehicle.metas, 'model')}`;
    line += ` แบบ: ${getMeta(vehicle.metas, 'type')}`;
    line += ` สี: ${getMeta(vehicle.metas, 'color')}`;
    line += ` เกียร์: ${getMeta(vehicle.metas, 'gear')}`;
    line += ` ขนาดเครื่องยนต์: ${getMeta(vehicle.metas, 'enginesize')}`;
    line += ` ทะเบียนรถยนต์: ${getMeta(vehicle.metas, 'plateNo')}`;
    line += ` หมายเลขเครื่องยนต์: ${getMeta(vehicle.metas, 'engineno')}`;
    line += ` เลขตัวถัง: ${getMeta(vehicle.metas, 'chassisno')}`;
    line += ` วันจดทะเบียน: ${new Date(
      getMeta(vehicle.metas, 'plateRegisDate')
    ).toLocaleDateString('th-TH')}`;
  }
  return line;
}
function getMeta(metas, key, defaultValue = '') {
  const item = metas.find((m) => m.key === key);
  return item && item.value ? item.value : defaultValue ? defaultValue : '';
}
const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ContractCard = () => {
  const { id } = useParams(); // Get ID from URL
  const [contract, setContract] = useState(null);
  const [schedule, setSchedule] = useState(null);
  const [modalContent, setModalContent] = useState(null); // Store content for modal
  const [open, setOpen] = useState(false); // Control modal visibility

  useEffect(() => {
    const fetchContract = async () => {
      // Replace this with your API call
      const response = await api.get(`/api/contracts/me?contractId=${id}`);
      const contract = response.data[0];

      const schedule = contract.statements.find(
        (ss) => ss.status === 1 || ss.status === 3
      );

      if (contract.type === 3) {
        const paid = contract.statements.filter(
          (ss) => ss.status === 0 || ss.status === 9
        );
        schedule.balance =
          contract.minimumPayment * (contract.duration - paid.length);

        setSchedule(schedule);
      } else {
        setSchedule(schedule);
      }

      setContract(contract);
    };

    fetchContract();
  }, [id]);

  // Open modal with content
  const openModal = (content, type) => {
    setModalContent(content);
    setOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setOpen(false);
    setModalContent(null);
  };

  if (contract === null) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <>
      <AppBar position="static" color="primary">
        <Toolbar>
          <IconButton edge="start" color="inherit" href="/contracts">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6">การ์ดลูกหนี้</Typography>
        </Toolbar>
      </AppBar>
      <Paper sx={{ p: 2, mt: 2 }}>
        <Typography variant="h6">ข้อมูลสัญญา</Typography>
        <Divider sx={{ my: 1 }} />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color="textSecondary">เลขที่สัญญา</Typography>
            <Typography variant="h6" color="primary">
              {contract.contractNumber}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography color="textSecondary">ชื่อ-สกุล</Typography>
            <Typography variant="h6" color="primary">
              {contract.profile.prefix}
              {contract.profile.firstName} {contract.profile.lastName}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography color="textSecondary">แบบการชำระ</Typography>
            <Typography variant="h6" color="primary">
              {contract.type === 1
                ? 'OD'
                : contract.type === 2
                ? 'OD Fix'
                : contract.type === 3
                ? 'รายเดือน'
                : 'ฟ้อง'}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography color="textSecondary">หลักทรัพย์</Typography>
            <ul>
              {contract.assets
                .sort((a, b) => {
                  if (a.name === 'Land' && b.name === 'Land') {
                    const deedNo = a.metas.find((m) => m.key === 'deedNo');
                    const deedNo2 = b.metas.find((m) => m.key === 'deedNo');
                    return deedNo.value - deedNo2.value;
                  }
                  return b.id - a.id;
                })
                .map((a, index) => (
                  <li key={index}>
                    <Typography>{extractAssets([a])}</Typography>
                  </li>
                ))}
            </ul>
          </Grid>

          <Grid item xs={12}>
            <Typography color="textSecondary">ยอดเงินกู้</Typography>
            <Typography variant="h6" color="primary">
              {contract.type !== 99
                ? contract.credit.toLocaleString()
                : 'ติดต่อบริษัท'}
            </Typography>
          </Grid>

          {contract.type !== 99 && (
            <Grid item xs={12}>
              <Typography color="textSecondary">อัตราดอกเบี้ย</Typography>
              <Typography variant="h6" color="primary">
                {contract.rate} %
              </Typography>
            </Grid>
          )}
          {contract.type === 99 && (
            <Grid item xs={12}>
              <Typography color="textSecondary">ค่างวด</Typography>
              <Typography variant="h6" color="primary">
                {contract.minimumPayment.toLocaleString()} บาท
              </Typography>
            </Grid>
          )}

          <Grid item xs={12}>
            <Typography color="textSecondary">วันที่ทำสัญญา</Typography>
            <Typography variant="h6" color="primary">
              {formatDate(contract.createdDate)}
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      <Paper sx={{ p: 2, mt: 2 }}>
        <Typography variant="h6">รายการเดินบัญชี</Typography>
        <Divider sx={{ my: 1 }} />
        <Typography>
          เงินต้นคงเหลือ:{' '}
          {contract.type !== 99
            ? `${schedule.balance?.toLocaleString()} บาท`
            : 'ติดต่อบริษัท'}
        </Typography>

        {contract.statements
          .filter((s) => s.paymentReference && s.paymentReference.referencesNo)
          .map((s, index) => (
            <Paper key={index} sx={{ p: 2, mt: 2 }}>
              {s.paymentReference ? (
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography color="textSecondary">
                      {formatDateTime(s.paymentReference.paymentDateTime)}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h6" color="primary">
                      {s.paymentReference.amount.toLocaleString()}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() =>
                        openModal(<Bill id={s.paymentReference.id} />, 'bill')
                      }
                    >
                      ดูใบเสร็จ
                    </Button>
                    {s.paymentReference.bankAccountId &&
                      s.paymentReference.fileId && (
                        <Button
                          variant="outlined"
                          size="small"
                          sx={{ ml: 1 }}
                          onClick={() =>
                            openModal(
                              <Slip fileId={s.paymentReference.fileId} />,
                              'slip'
                            )
                          }
                        >
                          ดูสลิปเงินโอน
                        </Button>
                      )}
                  </Grid>
                </Grid>
              ) : (
                <div flexitem="true">
                  <Typography sx={{ display: 'inline-block' }}>
                    ชำระงวดถัดไป ภายในวันที่
                  </Typography>
                  <Typography
                    color="secondary"
                    sx={{ display: 'inline-block', ml: 1 }}
                  >
                    {formatDate(s.balanceOnDate)}
                  </Typography>
                </div>
              )}
            </Paper>
          ))}
      </Paper>
      {/* Modal for Viewing Bills/Slips */}
      <Dialog
        open={open}
        onClose={closeModal}
        fullWidth
        maxWidth="sm"
        fullScreen
      >
        <DialogTitle>
          {modalContent?.type === 'bill' ? 'ใบเสร็จ' : 'สลิปเงินโอน'}
        </DialogTitle>
        <DialogContent>{modalContent}</DialogContent>
        <DialogActions
          sx={{
            alignContent: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button onClick={closeModal} color="primary">
            ปิด
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ContractCard;
